module.exports = __webpack_public_path__ + "static/media/student_icon.0d5528f8.png";